import { Modal } from 'bimui'
import './index.less'
import { Table, message } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { EngineContext } from '@/App';
import copy from 'copy-to-clipboard';

interface IProps {
    visible: boolean
    changeVisible: (visible: boolean) => void;
}

export default function UserHelpModal(props: IProps) {
    /**
     * 引擎上下文，用于管理全局的引擎实例。
     */
    const engineContext = useContext(EngineContext);

    const [cmdList, setCmdList] = useState<any[]>([]);

    useEffect(() => {
        if (!engineContext?.engine) return;
        const cmdList = engineContext.engine.storage.registerStore.cmdList;
        cmdList.sort((a, b) => a.cmd.localeCompare(b.cmd));
        setCmdList(cmdList);
    }, [engineContext.engine])

    /**
     * 复制命令到剪切板
     */
    const onCopyCmd = (cmd: string) => {
        copy(cmd);
        message.success('已复制到剪贴板！')
    }

    return (
        <>
            <Modal
                title="帮助"
                open={props.visible}
                mask
                wrapClassName='user-help-modal-container'
                width={860}
                canDrag
                showFooter={false}
                onCancel={() => props.changeVisible(false)}
            >
                <div className="data-box">
                    <div className="data-table">
                        <Table
                            rowKey="cmd"
                            pagination={false}
                            dataSource={cmdList}
                            bordered={false}
                            className='tn-common-table'
                            sticky
                        >
                            <Table.Column dataIndex="cmd"
                                title="命令"
                                ellipsis
                                width={300}
                                sorter={(a, b) => a.cmd?.localeCompare(b.cmd || '')} // 排序规则
                                showSorterTooltip={false} // 不显示排序图标
                                render={(value) => (
                                    <span style={{ cursor: 'default' }} onClick={() => onCopyCmd(value)}>{value}</span>
                                )}
                            />
                            <Table.Column dataIndex="desciption"
                                title="描述"
                                ellipsis
                            />
                        </Table>
                    </div>
                </div>
            </Modal>
        </>
    )
}